export type MermaidResolvedTheme = 'reader' | 'light' | 'dark';

export interface MermaidThemeConfig {
	theme: 'base';
	themeVariables: Record<string, string>;
}

const PALETTES: Record<MermaidResolvedTheme, Record<string, string>> = {
	reader: {
		background: '#f4f7f1', primaryColor: '#ffffff', primaryTextColor: '#202823', primaryBorderColor: '#2f6f55',
		secondaryColor: '#eaf0e6', tertiaryColor: '#f8faf6', lineColor: '#315b49', textColor: '#202823', edgeLabelBackground: '#f4f7f1',
		noteBkgColor: '#fff8dc', noteBorderColor: '#8a651c', noteTextColor: '#30250d',
	},
	light: {
		background: '#ffffff', primaryColor: '#f5f7fb', primaryTextColor: '#1d1d1f', primaryBorderColor: '#356da8',
		secondaryColor: '#eaf2fb', tertiaryColor: '#fafafa', lineColor: '#315f8f', textColor: '#1d1d1f', edgeLabelBackground: '#ffffff',
		noteBkgColor: '#fff8dc', noteBorderColor: '#8a651c', noteTextColor: '#30250d',
	},
	dark: {
		background: '#0a0a0b', primaryColor: '#1c1f24', primaryTextColor: '#f5f7fa', primaryBorderColor: '#7ab8f5',
		secondaryColor: '#172638', tertiaryColor: '#25272c', lineColor: '#c6d0dc', textColor: '#f5f7fa', edgeLabelBackground: '#161618',
		noteBkgColor: '#3b3219', noteBorderColor: '#e4bd58', noteTextColor: '#fff4cf',
	},
};

function normalizeTheme(theme: string | undefined): MermaidResolvedTheme {
	return theme === 'dark' || theme === 'light' ? theme : 'reader';
}

export function getMermaidThemeConfig(theme: string | undefined): MermaidThemeConfig {
	const palette = PALETTES[normalizeTheme(theme)];
	return {
		theme: 'base',
		themeVariables: {
			...palette,
			mainBkg: palette.primaryColor, nodeBorder: palette.primaryBorderColor,
			clusterBkg: palette.secondaryColor, clusterBorder: palette.primaryBorderColor, titleColor: palette.textColor,
			actorBkg: palette.primaryColor, actorBorder: palette.primaryBorderColor, actorTextColor: palette.primaryTextColor,
			signalColor: palette.lineColor, signalTextColor: palette.textColor,
			labelBoxBkgColor: palette.secondaryColor, labelBoxBorderColor: palette.primaryBorderColor, labelTextColor: palette.textColor,
			loopTextColor: palette.textColor, activationBkgColor: palette.secondaryColor, activationBorderColor: palette.primaryBorderColor,
			sequenceNumberColor: palette.primaryTextColor,
		},
	};
}
